import { useEffect } from 'react'
import { getUserStatusAction } from 'root-redux/actions/user'
import { TAppDispatch } from 'root-redux/store/store'
import { useDispatch, useSelector } from 'react-redux'
import { selectUUID } from 'root-redux/selects/user'

export const useSetUserStatus = () => {
  const dispatch: TAppDispatch = useDispatch()
  const uuid = useSelector(selectUUID)

  useEffect(() => {
    if (uuid) {
      dispatch(getUserStatusAction(uuid))
    }
  }, [dispatch, uuid])
}
